import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export function useScrollToPositionId(active = true) {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get("scrollId");

    useEffect(() => {
        if(!active || !id) return;

        const el = document.getElementById(id);
        if(!el) {
            console.warn("[useScrollToPosition] element id not found", id);
            return;
        }

        const elPositionY = el.getBoundingClientRect().top + window.scrollY;
        console.info("[useScrollToPosition] elPositionY", elPositionY);

        window.scrollTo(0, elPositionY);

        searchParams.delete('scrollId');
        setSearchParams(searchParams, { replace: true });
    }, [active, id, location.pathname, searchParams, setSearchParams]);
}